import { render } from "./MessageReceiver.vue?vue&type=template&id=1692c12b"
import script from "./MessageReceiver.vue?vue&type=script&lang=js"
export * from "./MessageReceiver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__